// src/socket.js
import { io } from "socket.io-client";

// const SOCKET_URL = "http://localhost:1200";
/* eslint-disable import/prefer-default-export */
const SOCKET_URL= process.env.REACT_APP_BASE_URL_SOCKET;

export const socket = io(SOCKET_URL, {
  transports: ["websocket"],
});
/* eslint-enable import/prefer-default-export */

